import { useContext, useState } from "react";
import styled from "styled-components";

import StatusContext from "common/store/StatusContext";

import PrimaryButton from "common/components/atoms/PrimaryButton";
import { useDailyReport } from "../hooks/useDailyReport";
import { PrintPanelTemplate } from "./PrintPanelTemplate";
import { SelectDayControl } from "../../../common/components/molecules/SelectDayControl";
import { Tab, Tabs } from "react-bootstrap";
import { SelectDayRangeControl } from "common/components/molecules/SelectDayRangeControl";
import { REPORT_TYPE } from "common/types/consts/Defines";

export const PrintDailyControl = (props: {
  title: string;
  printType: number;
  reportType: REPORT_TYPE;
}) => {
  const [date, setDate] = useState(new Date());

  const { getDailyReort, getRangeReorts } = useDailyReport();
  const { isLoading, setIsLoading, setLoadingMessage, setErrorMessage } = useContext(StatusContext);

  /**
   * 日付を指定して印刷
   */
  const execDayPrint = async () => {
    setErrorMessage("");

    setIsLoading(true);
    setLoadingMessage(`帳票"${props.title}"を作成中...`);
    const { succeeded, msg } = await getDailyReort(date, props.printType, props.title);
    setIsLoading(false);

    if (!succeeded) {
      setErrorMessage(msg);
    }
  };

  /**
   * 一括印刷
   * @param startDate
   * @param endDate
   */
  const execRangePrint = async (startDate: Date, endDate: Date) => {
    setErrorMessage("");

    setIsLoading(true);
    setLoadingMessage(`帳票"${props.title}"の一括出力を実行中...`);
    const { succeeded, msg } = await getRangeReorts(
      startDate,
      endDate,
      props.reportType,
      `${props.title}`
    );
    setIsLoading(false);

    if (!succeeded) {
      setErrorMessage(msg);
    }
  };

  return (
    <PrintPanelTemplate>
      <Tabs>
        <Tab eventKey={"normal"} title="通常">
          <InsideTab>
            <SelectDayControl date={date} dateChanged={setDate} />
            <PrimaryButton title="出力" size="sm" onClick={execDayPrint} disabled={isLoading} />
          </InsideTab>
        </Tab>
        <Tab eventKey={"bulk"} title="一括">
          <InsideTab>
            <SelectDayRangeControl
              disabled={isLoading}
              dateConfirmed={execRangePrint}
              okTitle="出力"
            />
          </InsideTab>
        </Tab>
      </Tabs>
    </PrintPanelTemplate>
  );
};

const InsideTab = styled.div`
  padding-top: 1rem;
  gap: 0.5rem;
`;
